export default function PortalHeaderClone({user, account}) {
  return (
    <>
      <style type="text/css">{portalCss}</style>
      <header className="header">
        <div className="header__left">
          <div style={{ padding: "15px 0px 0px 20px" }}>
            <div className="BG_LOGO_PORTAL"></div>
          </div>
        </div>
        <div className="header__center">
          <div className="header__nav">
            <div id="mnav" className="flex-container_mainnav">
              <div id="current">
                <a href="" title="Workbench">
                  <span style={{ whiteSpace: "nowrap" }}>
                    <div className="PORTAL_WORKBENCH"></div>&nbsp;Workbench
                  </span>
                </a>
              </div>
              <div>
                <a href="" title="Dashboard">
                  <span style={{ whiteSpace: "nowrap" }}>
                    <div className="PORTAL_DASHBOARD" />&nbsp;Dashboard
                  </span>
                </a>
              </div>
              <div>
                <a href="" title="Operations">
                  <span style={{ whiteSpace: "nowrap" }}>
                    <div className="PORTAL_OPERATIONS" />&nbsp;Operations
                  </span>
                </a>
              </div>
              <div>
                <a href="" title="Administration">
                  <span style={{ whiteSpace: "nowrap" }}>
                    <div className="PORTAL_ADMINISTRATION" />&nbsp;Administration
                  </span>
                </a>
              </div>
              <div>
                <a href="" title="Support">
                  <span style={{ whiteSpace: "nowrap" }}>
                    <div className="PORTAL_SUPPORT" />&nbsp;Support
                  </span>
                </a>
              </div>
            </div>
            <div id="snav" className="flex-container_subnav">
              <div id="current" className="dropdownnav dropdownnav_1_6">
                <a href="" title="Build">
                  <span style={{ whiteSpace: "nowrap" }}>&nbsp;Build</span>
                </a>
                <div style={{ display: "none" }}>
                  &nbsp;
                </div>
              </div>
              <div className="dropdownnav dropdownnav_2_6">
                <a href="" title="Test">
                  <span style={{ whiteSpace: "nowrap" }}>&nbsp;Test</span>
                </a>
                <div id="dropdownnav-content_2_6" className="dropdownnav-content" style={{ display: "none", visibility: "hidden" }}>
                  <a className="dropdownnav-href" href="" style={{ background: "rgba(255, 255, 255, 0.5)", display: "none", visibility: "hidden", color: "rgb(8, 76, 139)" }}>
                    <span style={{ background: "rgba(255, 255, 255, 0.5)", display: "none", visibility: "hidden", color: "rgb(8, 76, 139)", paddingLeft: "5px" }}>Test By Template</span> </a>
                  <a className="dropdownnav-href" href="f" style={{ background: "rgba(255, 255, 255, 0.5)", display: "none", visibility: "hidden", color: "rgb(8, 76, 139)" }}>
                    <span style={{ background: "rgba(255, 255, 255, 0.5)", display: "none", visibility: "hidden", color: "rgb(8, 76, 139)", paddingLeft: "5px" }}>Test By Workflow</span> </a>
                </div>
              </div>
              <div className="dropdownnav dropdownnav_3_6">
                <a href="" title="Schedule">
                  <span style={{ whiteSpace: "nowrap" }}>&nbsp;Schedule</span>
                </a>
                <div style={{ display: "none" }}>
                  &nbsp;
                </div>
              </div>
              <div className="dropdownnav dropdownnav_4_6">
                <a href="" title="Deploy">
                  <span style={{ whiteSpace: "nowrap" }}>&nbsp;Deploy</span>
                </a>
                <div style={{ display: "none" }}>
                  &nbsp;
                </div>
              </div>
              <div className="dropdownnav dropdownnav_5_6">
                <a href="" title="Migrate">
                  <span style={{ whiteSpace: "nowrap" }}>&nbsp;Migrate</span>
                </a>
                <div style={{ display: "none" }}>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header__right">
          <div className="header__sec" id="securnav">
            <div className="flex-container">
              <div id="loggedinas_Sel" style={{ verticalAlign: "center", alignItems: "center" }}>
                <a id="loggedinas" className="headlink" style={{ textAlign: "center", alignItems: "center", fontSize: "14px" }}><span className="hdrfont">Logged in as:&nbsp;{user}</span></a>
              </div>
              <div id="samlGroupLbl" style={{ display: "none", alignItems: "center" }}>
                <label htmlFor="samlGroupSel" className="hdrfont">&nbsp;Group&nbsp;</label><select className="hdrfont" id="samlGroupSel" name="samlGroup" style={{ display: "block" }}></select>
                <div id="samlGroupSel_loader" className="loader" style={{ position: "relative", visibility: "hidden", display: "none" }}></div></div>
              <div id="accChng_Sel" style={{ verticalAlign: "center", alignItems: "center" }}>
                <label htmlFor="accChngSel" className="hdrfont" style={{fontSize: "14px" }}>&nbsp;Account:&nbsp;</label><select id="accChngSel" name="chngAcc" className="hdrfont disabled" style={{ display: "block", fontSize: "14px" }}><option value="1">{account}</option></select>
                <div id="accChngSel_loader" className="loader" style={{ position: "relative", display: "none" }}></div></div>
              <div id="lock" style={{ width: "100px", verticalAlign: "middle", alignItems: "center" }}><label htmlFor="signout">
                <a id="signout" className="headlink" style={{ textAlign: "center", verticalAlign: "center" }} href=""><span className="hdrfont" style={{fontSize: "14px"}}><div className="PORTAL_SIGNOUT"/> Sign-out</span></a></label>
              </div>
            </div>
          </div>
          <input type="hidden" id="username" name="username" value="admin" />
          <input type="hidden" id="usergroup" name="usergroup" value="" />
          <input type="hidden" id="usergroupName" name="usergroupName" value="" />
          <input type="hidden" id="samlUsrGroups" name="samlUsrGroups" value="" />
          <div className="header__help">&nbsp;</div>
        </div>
      </header>
    </>)
}

const portalCss = `
  img {
    border: none;
  }
  /* generic formats */
  body {
    color: #414F5A;
    font-size: 11px;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
    line-height: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    //background: #CED1D8 url( /images/opage_bg.jpg );
    //background-repeat: repeat-x;
    margin: 0px 0px 0px 0px;
  }
  table {
    border-collapse:separate;
    border-spacing: inherit;
  }
  table.content {
    color: #414F5A;
    font-size: 11px;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
    line-height: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
  }
  form { margin: 0px; }

  /* header */
  td.headlbl {
    font-size: 11px;
    color:#FFFFFF;
    font-weight:bold;
  }
  th.head {
  background-image: url( /images/ban_bg_mid.jpg );
    background-repeat: repeat-x;
  }
  table.ohead {
    width: 100%;
    border: none;

  }

  /* opage */
  #opage { padding:2%; width:96%;}
  #opage .sb-inner { background:white; }
  #opage .sb-shadow { background:black; }
  #opage .sb-border { background:#42748B; }
  table.opage {
    width: 100%;
    border: none;
  }
  td.opage_top {
    background-image: url( /images/opage_border_top.gif );
    vertical-align:bottom;
    background-repeat: repeat-x;
  }
  td.opage_btm {
    background-image: url( /images/opage_border_btm.gif );
    background-repeat: repeat-x;
  }
  td.opage_lft {
    background-image: url( /images/opage_border_lft.gif );
    background-repeat: repeat-y;
  }
  td.opage_rt {
    background-image: url( /images/opage_border_rt.gif );
    background-repeat: repeat-y;
  }

  /* ipage */
  #ipage { border:none; width:100%; height:100%; padding:5px; }

  td.ipage {
    width: 100%;
  height: 99%;
  }
  table.ipage {
    width: 100%;
  height: 99%;
    border: none;
    background-color: #FFFFFF;
  }
  /* otable */
  table.otable {
    width: 100%;
  }
  td.otable_top {}
  td.otable_btm {}
  td.otable_lft {}
  td.otable_rt {}
  /* itable */
  table.itable {
    background-color: #FFFFFF;
    width:100%;
  }
  th.itable  {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    font-weight: normal;
    color: #FFFFFF;
    text-shadow: #FFFFFF;
    text-align: left;
    background-image: url( /images/itable_border_top.jpg );
    background-repeat: repeat-x;
  }
  td.itable {}
  td.itable_lft {
    background-image: url( /images/itable_border_lft.gif );
    background-repeat: repeat-y;
  }
  td.itable_rt {
    background-image: url( /images/itable_border_rt.gif );
    background-repeat: repeat-y;
  }
  td.itable_btm {
    background-image: url( /images/itable_border_btm.gif );
    background-repeat: repeat-x;
  }

  * logo branding*/
  h1#loginLogo{
    width: 168px;
    height: 64px;
    background-image: url(/images/BridgeGateLogo10x.png);
  }
  h1#dashboardLogo{
    width: 168px;
    height: 64px;
    background-image: url(/images/bglogo10x.png);
  }

  /* banner */
  td.banner {
    width: 100%;
  }
  table.banner {
    width: 100%;
    background-image: url( /images/banner_bg.jpg );
  }
  /* main_nav_section */
  #mnav div{
    display:inline;
  }
  #mnav a{
    float:left;
    padding:0px 0px 0px 10px;
    text-decoration:none;
    font-weight:bold;
    color:#FFFFFF;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:14px;
    letter-spacing: 1px;
    display:inline;
  }
  #mnav a span{
    float:left;
    display:block;
    padding:2px 10px 5px 0px;
    margin: 0 5px 0 0;
  }
  #mnav a span{
    loat:none;
  }
  #mnav a:hover{
    background-position: 0 -128px;
    background-color:rgba(27, 48, 97, 1);
  }
  #mnav a:hover span{
    background-position: 100% -128px;
    background-color:rgba(27, 48, 97, 1);
  }
  #mnav #current span{ /*currently selected tab*/
    background-position: 100% -64px;
    color:#FFFFFF;
    background-color:rgba(27, 48, 97, 1);
  }
  #mnav #current a{ /*currently selected tab*/
    background-position: 0 -64px;
  }
  #aTN_ICO {
    background:url("/images/dashboard.ico.gif") no-repeat center top;
    position:relative;
    z-index:99;
    padding: 5px 0px 7px 0px;
    margin:2px 0px 0px 0px;
  }
  #bTN_ICO {
    background:url("/images/operations.ico.gif") no-repeat center top;
    position:relative;
    z-index:99;
    padding: 5px 0px 7px 0px;
    margin:2px 0px 0px 0px;
  }
  #cTN_ICO {
    background:url("/images/administration.ico.gif") no-repeat center top;
    position:relative;
    z-index:99;
    padding: 5px 0px 7px 0px;
    margin:2px 0px 0px 0px;
  }
  #dTN_ICO {
    background:url("/images/administration.ico.gif") no-repeat center top;
    position:relative;
    z-index:99;
    padding: 5px 0px 7px 0px;
    margin:2px 0px 0px 0px;
  }
  #eTN_ICO {
    background:url("/images/support.ico.gif") no-repeat center top;
    position:relative;
    z-index:99;
    padding: 5px 0px 7px 0px;
    margin:2px 0px 0px 0px;
  }
  #CLOSEICO {
    width: 23px;
    height: 23px;
    background: transparent url("/images/alphacube/close.btn.gif") no-repeat 0 0;
    top:0px;
    right:0px;
    cursor:pointer;
    z-index:1000;
  }
  #PRINTICO {

  }
  #snav div{
    display:inline;
  }
  #snav a{
    float:left;
    padding:0px 0px 0px 10px;
    text-decoration:none;
    font-weight:bold;
    color:#0497D5;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:14px;
    letter-spacing: 1px;
    display:inline;
    background-color:rgba(27, 48, 97, 1);
  }
  #snav a span{
    float:left;
    display:block;
    padding:2px 10px 5px 0px;
    margin: 0 5px 0 0;
  }
  #snav a span{
    float:none;
  }
  #snav a:hover{
    background-position: 0 -128px;
    color:#ffffff;
  }
  #snav a:hover span{
    background-position: 100% -128px;
    color:#ffffff;
  }
  #snav a:hover{
    background-position: 0 -128px;
  }
  #snav #current a span{ /*currently selected tab*/
    background-position: 100% -64px;
    color:#ffffff;
    background-color:rgba(27, 48, 97, 1);
  }
  #snav #current a{ /*currently selected tab*/
    background-position: 0 -64px;
    background-color:rgba(27, 48, 97, 1);
    color:#ffffff;
  }
  #snav #current a div a { /*currently selected tab*/
    background-position: 0 -64px;
    background-color:#0a0a0a;
    color:#ffffff;
  }
  /* sub_nav_section */
  td.sub_nav{
    background-image: url( /images/main_nav_active_bg.jpg );
    background-repeat:repeat;
  }
  td.sub_shdw{
    background-image: url( /images/shadow.jpg );
    background-repeat:repeat-x;
  }

  /* tabs_section */
  #tabsG {
    float:left;
    width:100%;

    line-height:normal;
  }
  #tabsG ul {
    margin:0;
    padding:10px 10px 0 50px;
    list-style:none;
  }
  #tabsG li {
    display:inline;
    margin:0;
    padding:0;
  }
  #tabsG a {
    float:left;
    margin:0;
    padding:0 0 0 4px;
    text-decoration:none;
    font-family: Arial, Helvetica, sans-serif;
    font-weight:600;
    font-size: 11px;
  }
  #tabsG a span {
    float:left;
    display:block;
    padding:5px 15px 4px 6px;
    color:#FFF;
  }
/* Commented Backslash Hack hides rule from IE5-Mac \*/
  #tabsG a span {float:none;}
  /* End IE5-Mac hack */
  #tabsG a:hover span {
    color:#FFF;
  }
  #tabsG a:hover {
    background-position:0% -42px;
  }
  #tabsG a:hover span {
    background-position:100% -42px;
  }
  #tabsG #current a {
    background-position:0% -42px;
  }
  #tabsG #current a span {
    background-position:100% -42px;
  }

  /*form section */
  .formsection_border{
    border:1px solid #CCCCCC;
  }
  .formsubsection_border{
    border:1px dashed #CCCCCC;
  }
  .formsection_tip{
    font-weight:bold;
  }
  #formsection_title{
    padding: 0px 10px;
    -moz-border-radius: 5px 5px 0px 0px;
    z-index:99;
    color:#000000;
    font-weight:bold;
    position:absolute;
    font-family: Arial, Helvetica, sans-serif;
    font-size:12px;
  }

  #formsection_title1{
    padding: 0px 10px;
    -moz-border-radius: 5px 5px 0px 0px;
    z-index:99;
    color:#000000;
    font-weight:bold;	
    font-family: Arial, Helvetica, sans-serif;
    font-size:12px;
    width:84px;
  }

  #formsubsection_title{
    padding: 0px 10px;
    -moz-border-radius: 5px 5px 0px 0px;
    z-index:99;
    color:#000000;
    font-weight:bold;
    font-family: Arial, Helvetica, sans-serif;
    font-size:12px;
    width:140px;
  }

  .formsection_fields_bg{
    background-color:rgba(241, 244, 249, 1);
  }

  /* form inputs */
  select {color:#000000; background-color:#ffffff;}
  select.accbox {
    color:#000000;
    background-color:#FFFFFF;
    font-size:11px;
    font-family: Arial, Helvetica, sans-serif;
  }

  INPUT{ font-size:11.5px; padding: 2px; border: inset 1px #8EA7CB; color:#000000; background-color:#FFFFFF;}
  TEXTAREA{font-size:11.5px; padding: 2px; border: inset 1px #8EA7CB; color:#000000; background-color:#FFFFFF;}
  SELECT, OPTION{font-size:11.5px;}
  INPUT[disabled]{
    font-size:11.5px;
    padding: 2px;
    border: inset 1px #8EA7CB;
    color:#999999;
  }
  input.file {
    font-size:11px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight:500;
  }
  .pbutton {
    -moz-box-shadow:inset 0px 1px 0px 0px #dcecfb;
    -webkit-box-shadow:inset 0px 1px 0px 0px #dcecfb;
    box-shadow:inset 0px 1px 0px 0px #dcecfb;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #08569c), color-stop(1, #243D7D));
    background:-moz-linear-gradient(top, #08569c 5%, #243D7D 100%);
    background:-webkit-linear-gradient(top, #08569c 5%, #243D7D 100%);
    background:-o-linear-gradient(top, #08569c 5%, #243D7D 100%);
    background:-ms-linear-gradient(top, #08569c 5%, #243D7D 100%);
    background:linear-gradient(to bottom, #08569c 5%, #243D7D 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#08569c', endColorstr='#243D7D',GradientType=0);
    background-color:#08569c;
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    border-radius:4px;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-weight:600;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:11px;
    font-variant:normal;
    padding:6px 24px;
    text-decoration:none;
    text-shadow:0px 1px 0px #528ecc;
  }
  .pbuttonwht {
    -moz-box-shadow:inset 0px 1px 0px 0px rgba(241, 244, 249, 1);
    -webkit-box-shadow:inset 0px 1px 0px 0px rgba(241, 244, 249, 1);
    box-shadow:inset 0px 1px 0px 0px #dcecfb;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #ffffff), color-stop(1, rgba(241, 244, 249, 1)));
    background:-moz-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-webkit-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-o-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-ms-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:linear-gradient(to bottom, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='rgba(241, 244, 249, 1)',GradientType=0);
    background-color:#ffffff;
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    border-radius:4px;
    display:inline-block;
    cursor:pointer;
    color:rgba(27, 48, 97, 1);
    font-weight:600;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:11px;
    font-variant:normal;
    padding:6px 24px;
    text-decoration:none;
    text-shadow:0px 1px 0px rgba(241, 244, 249, 1);
  }
  .buttonEnding {
    display:none;
  }

  /* gen links */
  a.smenu_links:link {font-size:12px; font-family: Arial, Helvetica, sans-serif; font-weight:600; text-decoration:none; color: #FFFFFF; font-size: 12px; outline:none;}
  a.smenu_links:visited {font-size:12px;color: #FFFFFF; text-decoration:none; font-family: Arial, Helvetica, sans-serif; font-weight:600;outline:none;}
  a.smenu_links:active {font-size:12px;color: #70abac; text-decoration:underline; font-family: Arial, Helvetica, sans-serif; font-weight:600;outline:none;}
  a.smenu_links:hover {font-size:12px;color: #FFFFFF;text-decoration:underline; font-family: Arial, Helvetica, sans-serif; font-weight:600;outline:none;}

  a.headlink:link {font-size:12px;font-family: Arial, Helvetica, sans-serif; text-decoration:none; color: #ffffff; font-size: 12px; font-weight:normal;outline:none;}
  a.headlink:visited {font-size:12px;font-family: Arial, Helvetica, sans-serif; color: #ffffff; text-decoration:none; font-weight:normal;outline:none;}
  a.headlink:active {font-size:12px;font-family: Arial, Helvetica, sans-serif; color: #70abac; text-decoration:underline; font-weight:normal;outline:none;}
  a.headlink:hover {font-size:12px;font-family: Arial, Helvetica, sans-serif; color: #ffffff;text-decoration:underline; font-weight:normal;outline:none;}

  a:link {color: blue; text-decoration:none; outline:none;}
  a:visited {color: blue; text-decoration:none; outline:none;}
  a:active {color: #900; text-decoration:underline; outline:none;}
  a:hover {color: #900; text-decoration:underline; outline:none;}

/* help link*/
  a.help {
    right:45px;
  }
  a.help:link {
    color: #FF6347;
    text-decoration:none;
    cursor:pointer;
    outline:none;
    border:none;
  }
  a.help:visited {
    color: #FF6347;
    text-decoration:none;
    cursor:pointer;
    outline:none;
    border:none;
  }
  a.help:active {
    color: #FF6347;
    text-decoration:underline;
    cursor:pointer;
    outline:none;
    border:none;
  }
  a.help:hover {
    color: #FF6347;
    text-decoration:underline;
    cursor:pointer;
    outline:none;
    border:none;
  }
  /* dbPoolProperties link*/
  a.dbPoolProperties:link {
    text-decoration:none;
    cursor:pointer;
    outline:none;
    border:none;
  }

  /* ajax */
  /* loader group */
  .loader {
    background-image: url( /images/loader_anim.gif );
    background-repeat:no-repeat;
    position:absolute;
    width:70px;
    height:10px;
  }
  td.loadertd {
    width:10%;
  }
  #ajaxfld{
    position:inherit;
  }
  .loader-circle {
    background-image: url( /images/ajax-loader-circle.gif );
    background-repeat:no-repeat;
    position:absolute;
    width:100px;
    height:100px;
  }

  /* shadows */
  .dropshadow2{
    float:left;
    clear:left;
    background: url(/images/shadow.gif) no-repeat bottom right;
    margin: 10px 0 10px 10px !important;
    margin: 10px 0 10px 5px;
    width: 500px;
    padding: 0px;
  }
  .innerbox{
    position:relative;
    bottom:6px;
    right: 6px;
    border: 1px solid #999999;
    padding:4px;
    margin: 0px 0px 0px 0px;
    background-color:#FFFFFF;
  }
  .innerbox{
    /* IE5 hack */
    \margin: 0px 0px -3px 0px;
    ma\rgin:  0px 0px 0px 0px;
    background-color:#FFFFFF;
  }
  .innerbox p{
    font-size:14px;
    margin: 3px;
    background-color:#FFFFFF;
  }
  .innerb {height:15em; overflow-x: hidden; overflow-y: auto; z-index:9998;}
  .scrollContainer {width:100%; margin:5px auto; border-bottom:1px #FFFFFF dotted; }
  .scroll {width:99%; border-bottom:1px #FFFFFF dotted;}
  .recurDivs{
    position:absolute;
    top:0;
    left:0;
    height:100px;
    width:100px;
    white-space: nowrap;
  }
  .hoverActive{
    border: 1px dotted #333333;
  }
  #modal_container {
    background-color:rgba(241, 244, 249, 1); border:1px  double #000;
  }

  #modal_overlay {
    BACKGROUND-COLOR: #000
  }
  /* txn detail css*/
  .table {  border:1px solid #CCCCCC;}
  .scroller {width: 90%; overflow: scroll; border: 0 solid #666; padding: 8px; position: relative }
  .chartscroller {width: 700px; border: 0 solid #84ABD4; padding: 8px; position: relative }
  .chartscrollbar {scrollbar-base-color:#84ABD4;}
  .smallRedError { font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: bold; color: #FF0000; text-decoration: none}
  .black { font-family: Arial, Helvetica, sans-serif; font-size: 11px; font-weight: normal; color: #333333 ; text-decoration: none }
  a.small {  font-family: Arial, Helvetica, sans-serif; font-weight: bold; font-size: 11px; color: #00007B; text-decoration: none}
  a.small:hover {  font-family: Arial, Helvetica, sans-serif; font-weight: bold; font-size: 11px; color: #00007B; text-decoration: underline}
  .medBlack { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #333333 }
  .smallBlack{  font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #333333}
  .small_form_hd {  font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #333333; font-weight: bold;}
  .smallRedError { font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: bold; color: #FF0000; text-decoration: none}
  .medRedError { font-family: Arial, Helvetica, sans-serif; font-size: 11px; font-weight: bold; color: #FF0000; text-decoration: none}
  .medGreenStatus { font-family: Arial, Helvetica, sans-serif; font-size: 11px; font-weight: bold; color: #339900; text-decoration: none}
  .darkBlueHome { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #00007B ; line-height: 20px; font-weight: bold}
  /*progress bar*/
  #progressBar { padding-top: 5px; }
  #progressBarBox { width: 350px; height: 20px; border: 1px inset; background: #eee;}
  #progressBarBoxContent { width: 0; height: 20px; border-right: 1px solid #444; background: #0A246A; }

  .kvheader{ text-align:center;}
  .kvdata{border: 1px solid #aaa; padding: 2px !important;}

  #srvr_grp{background-color:rgba(241, 244, 249, 1); border:1px  double #000;}
  .srvr{ background-color:rgba(241, 244, 249, 1);}
  .srvrStat{ text-align: left;}
  .srvrStatHdr{
    margin:2px 0px 2px 0px;
    padding:0px 0px 0px 0px;
    color: black;
    font: bold 12px Arial, Helvetica, sans-serif;
    text-align: left;}
  .srvrStatLbl{
    color: #000000;
    text-shadow: #000000;
    text-align: left;
    font-weight: bold;
  }
  .statslog{
    border:1px  double #000;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 9px;
    color: #333333;
    scrollbar-base-color: #E6E6E6;
    background-color: #F1F1F9;
    width: 600px;
  }
  .blueLbl{
    color: #FFFFFF;
    text-shadow: #FFFFFF;
    text-align: center;
    background-image: url( /images/itable_border_top.jpg );
    background-repeat: repeat-x;}
  .blueLblLft{
    color: #FFFFFF;
    text-shadow: #FFFFFF;
    text-align: left;
    background-image: url( /images/itable_border_top.jpg );
    background-repeat: repeat-x;}
  #bamalert-0{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_error_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #bamalert-1{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_error_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #bamwarn-0{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_warn_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #bamwarn-1{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_warn_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #bamcomply-0{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_infocheck_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #bamcomply-1{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_info_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #connmon-comply-1{
    width: 57px;
    height: 56px;
    background: transparent url("/images/message_info_solid.gif") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom:5px;
  }
  #bamsection_title{
    padding: 0px 10px;
    -moz-border-radius: 5px 5px 0px 0px;
    z-index:99;
    color:#FFFFFF;
    font-weight:bold;
    font-family: Arial, Helvetica, sans-serif;
    font-size:18px;
  }
  #bamAlerts{
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 12px;
    color: #333333;
  }
  a.bam:link {font-size: 12px; color: blue; text-decoration:none; outline:none;}
  a.bam:visited {font-size: 12px; color: blue; text-decoration:none; outline:none;}
  a.bam:active {font-size: 12px; color: #900; text-decoration:underline; outline:none;}
  a.bam:hover {font-size: 12px; color: #900; text-decoration:underline; outline:none;}
  #bamdivider{
    width: 4px;
    background: transparent url("/images/bam/divider.png") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
  }
  .clear { clear: both;}
    #bamcontainer{ vertical-align: middle; text-align:center; }
    #bamleft{width: 200px; border:0; float: left}
    #bamright{border:0; float: left}
    .bamsection_container{
  }
/* bamitable */
  table.bamitable {
    width:100%;
  }
  th.bamitablealert  {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: #FFFFFF;
    text-align: left;
    background-image: url( /images/bam/alert_itable_border_top.jpg );
    background-repeat: repeat-x;
  }
  th.bamitablewarn  {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: #FFFFFF;
    text-align: left;
    background-image: url( /images/bam/warn_itable_border_top.jpg );
    background-repeat: repeat-x;
  }
  th.bamitablecompliant  {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: #FFFFFF;
    text-align: left;
    background-image: url( /images/bam/comply_itable_border_top.jpg );
    background-repeat: repeat-x;
  }
  td.bamitable {}
  td.bamitable_lft {
    background-image: url( /images/bam/itable_border_lft.gif );
    background-repeat: repeat-y;
  }
  td.bamitable_rt {
    background-image: url( /images/bam/itable_border_rt.gif );
    background-repeat: repeat-y;
  }
  td.bamitable_btm {
    background-image: url( /images/bam/itable_border_btm.gif );
    background-repeat: repeat-x;
  }
  option.imagebacked {
    width: 57px;
    height: 56px;
    padding: 2px 0 2px 20px;
    background-repeat: no-repeat;
    background-position: 1px 2px;
    vertical-align: middle;
  }
  .typeImg{
    position:absolute;
    top:0;
    left:0;
    height:57px;
    width:57px;
    white-space: nowrap;
  }
  tr.even {
    background-color: rgba(241, 244, 249, 1);
    vertical-align:top;
  }
  tr.odd {
    background-color: #FFFFFF;
    vertical-align:top;
  }
  #conn_mon_divider{
    width: 4px;
    height: 250px;
    background: transparent url("/images/bam/conn_mon_divider.png") no-repeat center top;
    position:relative;
    z-index:1000;
    vertical-align:middle;
    text-align:center;
    margin: 7px 0px 0px;
  }
  .div-container3 {
    overflow: hidden;
    width: 100%;
  }
  .scroll-container {
  }
  .float-left {
    float:left;
  }
  .float-rt {
    float:right;
  }

  input.button {
    -moz-box-shadow:inset 0px 1px 0px 0px rgba(241, 244, 249, 1);
    -webkit-box-shadow:inset 0px 1px 0px 0px rgba(241, 244, 249, 1);
    box-shadow:inset 0px 1px 0px 0px #dcecfb;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #ffffff), color-stop(1, rgba(241, 244, 249, 1)));
    background:-moz-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-webkit-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-o-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-ms-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:linear-gradient(to bottom, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='rgba(241, 244, 249, 1)',GradientType=0);
    background-color:#ffffff;
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    border-radius:4px;
    display:inline-block;
    cursor:pointer;
    color:rgba(27, 48, 97, 1);
    font-weight:600;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:11px;
    font-variant:normal;
    padding:6px 24px;
    text-decoration:none;
    text-shadow:0px 1px 0px rgba(241, 244, 249, 1);
  }
  input.button:active {
    position:relative;
    top:1px;
  }
  input.button:focus{
    outline:none;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, rgba(241, 244, 249, 1)), color-stop(1, #ffffff));
    background:-moz-linear-gradient(top, rgba(241, 244, 249, 1) 5%, #ffffff 100%);
    background:-webkit-linear-gradient(top, rgba(241, 244, 249, 1) 5%, #ffffff 100%);
    background:-o-linear-gradient(top, rgba(241, 244, 249, 1) 5%, #ffffff 100%);
    background:-ms-linear-gradient(top, rgba(241, 244, 249, 1) 5%, #ffffff 100%);
    background:linear-gradient(to bottom, rgba(241, 244, 249, 1) 5%, #ffffff 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='rgba(241, 244, 249, 1)', endColorstr='#ffffff',GradientType=0);
    background-color:rgba(241, 244, 249, 1);
  }
  input.button:disabled {
    -moz-box-shadow:inset 0px 1px 0px 0px rgba(241, 244, 249, 1);
    -webkit-box-shadow:inset 0px 1px 0px 0px rgba(241, 244, 249, 1);
    box-shadow:inset 0px 1px 0px 0px #dcecfb;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #ffffff), color-stop(1, rgba(241, 244, 249, 1)));
    background:-moz-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-webkit-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-o-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:-ms-linear-gradient(top, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    background:linear-gradient(to bottom, #ffffff 5%, rgba(241, 244, 249, 1) 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='rgba(241, 244, 249, 1)',GradientType=0);
    background-color:rgba(241, 244, 249, 1);
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    border-radius:4px;
    display:inline-block;
    cursor:default;
    color:rgba(27, 48, 97, 1);
    font-weight:500;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:11px;
    font-variant:normal;
    padding:6px 24px;
    text-decoration:none;
    text-shadow:0px 1px 0px rgba(241, 244, 249, 1);
  }
  input.buttonblu {
    -moz-box-shadow:inset 0px 1px 0px 0px #dcecfb;
    -webkit-box-shadow:inset 0px 1px 0px 0px #dcecfb;
    box-shadow:inset 0px 1px 0px 0px #dcecfb;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #08569c), color-stop(1, #004a8d));
    background:-moz-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:-webkit-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:-o-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:-ms-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:linear-gradient(to bottom, #08569c 5%, #004a8d 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#08569c', endColorstr='#004a8d',GradientType=0);
    background-color:#08569c;
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    border-radius:4px;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-weight:600;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:11px;
    font-variant:normal;
    padding:6px 24px;
    text-decoration:none;
    text-shadow:0px 1px 0px #528ecc;
  }
  input.buttonblu:active {
    position:relative;
    top:1px;
  }
  input.buttonblu:focus{
    outline:none;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #004a8d), color-stop(1, #08569c));
    background:-moz-linear-gradient(top, #004a8d 5%, #08569c 100%);
    background:-webkit-linear-gradient(top, #004a8d 5%, #08569c 100%);
    background:-o-linear-gradient(top, #004a8d 5%, #08569c 100%);
    background:-ms-linear-gradient(top, #004a8d 5%, #08569c 100%);
    background:linear-gradient(to bottom, #004a8d 5%, #08569c 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#004a8d', endColorstr='#08569c',GradientType=0);
    background-color:#004a8d;
  }
  input.buttonblu:disabled {
    -moz-box-shadow:inset 0px 1px 0px 0px #dcecfb;
    -webkit-box-shadow:inset 0px 1px 0px 0px #dcecfb;
    box-shadow:inset 0px 1px 0px 0px #dcecfb;
    background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #08569c), color-stop(1, #004a8d));
    background:-moz-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:-webkit-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:-o-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:-ms-linear-gradient(top, #08569c 5%, #004a8d 100%);
    background:linear-gradient(to bottom, #08569c 5%, #004a8d 100%);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#08569c', endColorstr='#004a8d',GradientType=0);
    background-color:#004a8d;
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    border-radius:4px;
    display:inline-block;
    cursor:default;
    color:#968A6D;
    font-weight:500;
    text-align:center;
    font-family: Arial, Helvetica, sans-serif;
    font-size:11px;
    font-variant:normal;
    padding:6px 24px;
    text-decoration:none;
    text-shadow:0px 1px 0px #528ecc;
  }
  #sitelists{
    height: 21em;
    min-height: 21em;
  }
  #availableSites, #assignedSites {
    width: 100%;
    height: 18em;
    min-height: 18em;
    list-style-type: none;
    margin: 0;
    padding: 0;
    display:inline-block;
    vertical-align:top;
    margin-right: 10px;
    text-align: left;
  }
  #availableSites li, #assignedSites li {
    margin: 0 5px 5px 5px;
    padding: 5px;
    width: 100%;
    background-color:rgba(241, 244, 249, 1);
  }
  #availableSites li.selected, #assignedSites li.selected {
    background-color:#CCCCCC;
  }
  .siteplaceholder{
    height: 200px;
    border: 1px dashed lightblue;
    font-weight: bold;
    font-size: 45px;
    background-color: rgba(241, 244, 249, 1);
  }
  #sitesAssigned{
    display:none;
  }
  .assignedSitesTD{
    margin-left: 5px;
    border-left: 2px solid white;
  }
  .scrollable {
    width:400px;
    height:160px;
    overflow: auto;
    max-width:350px;
    max-height:140px;
    margin:0px 10px 0px 0px;
  }
  .visuallyhidden {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px; width: 1px;
    margin: -1px; padding: 0; border: 0;
  }


  .display-table {
    display: table;
    width: 100%;
    background-color: rgba(241, 244, 249, 1);
  }
  .display-table > div {
    display: table-row;
  }
  .display-table > div > div {
    display: table-cell;
    padding: 0px 0px 2px 0px;
    width: 20%;
    text-align: center;
    border-right: 3px solid white;
  }
  .display-table > div > div > div {
    display: inline-block;
    text-align: left;
    white-space: nowrap;
  }
  .display-table > div > div > div > div > label {
    display: block;
    font-weight: bold;
    white-space: nowrap;
    margin: 4px 0px 0px 0px;
  }
  .header {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    position: relative;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 0px 0px;
    background-color: #243D7D;
  }
  [class*="header__"] {
    border: none;
  }
  .header__left {
    -ms - flex: 1 1 280px; /* IE 10 */
    flex:  1 1 280px;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    text-align: left;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 0px 0px;
    width: 10vw;
    display: flex;
    flex-wrap: wrap;
    /*min-width: 280px;*/
  }
  .header__center {
    -ms - flex: 1 1 750px; /* IE 10 */
    flex:  1 1 750px;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    text-align: center;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 0px 0px;
  }
  .header__right {
    -ms - flex: 1 1 110px; /* IE 10 */
    flex:  1 1 110px;
    -webkit-align-items: flex-end;
    align-items: flex-end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    flex-wrap: nowrap;
    text-align: right;
    padding: 0px 0px 0px 80px;
    margin: 0px 0px 0px 0px;
  }
  .header__sec {
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px 20px 5px 0px;
  }
  .header__help {
    margin: 0px 20px 5px 0px;
    position: absolute;
    bottom: 0;
    right: 0;
    color: #F37B30;
    font-size: 12px;
  }
  .flex-container {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap: nowrap;
  }
  .flex-container > div {
    margin: 0;
    padding:0px 5px 0px 5px;
    text-align: center;
    line-height: 20px;
    font-size: 11px;
    color: #ffffff;
  }
  #loggedinas_Sel {
    left: 0px;
    top: 0px;
    text-align: right;
  }
  #loggedinas_Sel label {
    float: left;
    margin: 1px;
  }
  #samlGroupLbl {
    left: 0px;
    top: 0px;
    text-align: right;
  }
  #samlGroupLbl label {
    float: left;
    margin: 1px;
  }
  #accChng_Sel {
    left: 0px;
    top: 0px;
    text-align: right;
  }
  #accChng_Sel label {
    float: left;
    margin: 1px;
  }
  #accChng_Sel select {
    margin: 1px 0px 0px 0px;
  }
  #lock label {
    margin: 1px 0px 0px 0px;
  }
  .header__nav {
    margin: 35px 0px 0px 0px;
  }
  .flex-container_mainnav {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .flex-container_mainnav > div {
    margin: 0;
    padding:0px 5px 0px 5px;
    text-align: center;
    line-height: 25px;
    font-size: 11px;
    color: #ffffff;
  }
  .flex-container_subnav {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    background-color: rgba(27, 48, 97, 1);
  }
  .flex-container_subnav > div {
    margin: 0;
    padding:0px 5px 0px 5px;
    text-align: center;
    line-height: 20px;
    font-size: 11px;
    color: #ffffff;
    background-color: rgba(27, 48, 97, 1);
  }
  .dropdownnav {
    position: relative;
    display: inline-block;
  }

  .dropdownnav-content {
    display: none;
    visibility: hidden;
    position: absolute;
    background-color: #ffffff;
    background: rgba(255, 255, 255, 0.5);
    color:#243D7D;
    min-width: 160px;
    z-index: 999;
    left: 0;
    top: 26px;
    border-top: 1px solid rgba(27, 48, 97, 1);
    padding-bottom: 10px;
  }
  .dropdownnav-href{
    display: none;
    visibility: hidden;
    line-height:20px;
    width:250px;
    border: none;
    text-align:left;
    background-color: #ffffff;
    background: rgba(255, 255, 255, 0.5);
    color:#243D7D;
    white-space: nowrap;
  }
  .dropdownnav-href span{
    display: none;
    visibility: hidden;
    background-color: #ffffff;
    background: rgba(255, 255, 255, 0.5);
    color:#243D7D;
    text-align:left;
  }
  .dropdownnav-href #current{
    display: none;
    visibility: hidden;
    background-color: #ffffff;
    background: rgba(255, 255, 255, 0.5);
    color:#1a1a1a;
    text-align:left;
  }
  .hdrfont{
    font - size: 14px;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
  }
`